<template>
    <div>
        <div class="fw-gwitems">
            <van-tree-select
                    style="width: 100%"
                    :height="kdStyle"
                    :items="list"
                    :main-active-index.sync="activeIndex"
                    @click-nav="getGwItems"
                    v-if="list.length>0"
            >
                <template slot="content">
                    <div class="fw-gwitems-r">
                        <div class="fwgr-item" v-for="item in items">
                            <div class="fwgr-item-info">
                                <span class="mc">{{item.skuName}}</span>
                                <span class="jg">¥{{item.retailPrice}}</span>
                            </div>
                            <el-button size="mini" @click="toChoose(item)">选择</el-button>
                        </div>
                    </div>
                </template>
            </van-tree-select>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.skuName}}</span>
                    <span class="jg">¥{{item.retailPrice}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">调整价格</span>
                        <el-input v-model="item.total" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" (emp,index) in fEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,1)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in sEmps">
                            <span class="empname" :class="{hui: emp.check}"  @click="setEmp(emp,2)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in tEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,3)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                activeIndex: 0,
                list:[],
                items:[],


                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                total:0,
                mc:{},
            };
        },
        props:{
            mbCard:Object,
            kdStyle:String
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            if (this.mbCard&&this.mbCard.id){
                this.mc=this.mbCard
            }
            this.getCatItems()
        },
        methods: {
            //切换会员卡
            qiehuan(mc){
                if (mc&&mc.id){
                    this.mc=mc
                }else {
                    this.mc={}
                }
            },

            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getEmpCatSkus", data)
                this.list = res.list
                if (res.list.length > 0) {
                    this.items = res.list[0].gwSkus
                }
            },

            getGwItems(index) {
                this.items= this.list[index].gwSkus
            },
            toChoose(item) {
                this.show = true
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.total = newItem.retailPrice
                //计算会员价格
                this.mcjiage(item,newItem)
                this.item = newItem
                this.getFwEmps()
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            addData() {
                let emps = []
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                let item = this.item
                let newItem ={
                    itemId: item.id,
                    categoryId: item.categoryId,
                    storeDeptId: item.storeDeptId,
                    itemName: item.skuName,
                    cmnVal: item.cmnVal,
                    cost: item.cost,
                    price: item.total,
                    oglPrice: item.retailPrice,
                    fdCmnVal: item.fdCmnVal,
                    itemSign: 0,
                    actual: 0,
                    add: 0,
                    // discount: item.discount,
                    noteId: '',
                    tjType: 0,
                    emps: emps,
                };
                var total = parseFloat(this.total) + parseFloat(item.total)
                this.total = total.toFixed(1)
                let data ={
                    item:newItem,
                    total:item.total
                }
                this.$emit('toSkuChoose',data)
                this.show = false
            },
            //设置员工
            async setEmp(item) {
                    item.check = !item.check
            },

            // 将选中的人状态更改为没选中
            setUnchecked() {
                this.changeEmpFalse(this.emps);
            },

            //更改状态
            changeEmpTrue(emps, emp, check) {
                emps.forEach(item => {
                    if (emp.empId == item.id) {
                        item.check = check
                    }
                })
            },

            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    item.check = false
                })
            },
            mcjiage(item,newItem){
                //计算会员价
                if (this.mc && this.mc.id) {
                    if (this.mc.skuDiscount > 0) {
                        newItem.total = this.calculationPrice(item.retailPrice, this.mc.skuDiscount)
                    }
                }
            },
            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
        },
    };
</script>

<style lang="scss" scoped>


</style>
